import { ToggleButton, ToggleButtonGroup } from '@mui/material';
import { styled } from '@mui/material/styles';

export const StyledToggleButtonGroup = styled(ToggleButtonGroup)(({ theme }) => ({
  position: 'relative',
  backgroundColor: theme.palette.grey[100],
  borderRadius: 40,
  transition: '0.3s',
  color: '#949494 !important',
  '&:hover': {
    backgroundColor: theme.palette.primary.dark,
    color: 'white !important',
  },
  width: 150,
  [theme.breakpoints.down('md')]: {
    width: 75,
  },
}));

export const StyledToggleButton = styled(ToggleButton)({
  borderRadius: 20,
  '.MuiToggleButtonGroup-grouped:not(:last-of-type)': {
    borderTopRightRadius: 0,
    borderBottomRightRadius: 0,
    marginRight: 2,
  },
  border: 'none',
  backgroundColor: 'transparent !important',
  color: 'inherit !important',
  width: '50%',
});

export const ToggleIndicator = styled('div')(({ theme }) => ({
  position: 'absolute',
  background: theme.palette.primary.main,
  borderRadius: 20,
  width: 'calc(50% + 12px)',
  height: 'calc(100% + 6px)',
  borderWidth: 3,
  borderColor: 'white',
  borderStyle: 'solid',
  pointerEvents: 'none',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  transition: '0.3s',
  top: '50%',
  left: -6,
  transform: 'translateY(-50%)',
  color: 'white',
}));
